// extracted by mini-css-extract-plugin
export default {"link":"lO-z","disabled":"mO-z"};